export default "__VITE_ASSET__BRYQiJhq__"